module.exports = __webpack_public_path__ + "img/page3.4e08ee54.png";